import React, { useState } from "react";
import { Layout, Menu, Typography, Dropdown, Button, Space, Drawer, Grid } from "antd";
import {
  CarryOutOutlined,
  TeamOutlined,
  AppstoreOutlined,
  LogoutOutlined,
  AndroidOutlined,
  UserOutlined,
  CloudDownloadOutlined,
  MenuOutlined,
  DatabaseOutlined,
  InboxOutlined,
  FileSearchOutlined,
  TagOutlined,
  GlobalOutlined,
  CarOutlined
} from "@ant-design/icons";

import { useNavigate, Outlet } from "react-router-dom";
import logo from "../logo.png";

const { Sider, Content, Header } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MainLayout = () => {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const nombreUsuario = localStorage.getItem("usuario") || "Usuario";
  const userRole = localStorage.getItem("rol") || "Operador";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    localStorage.removeItem("rol");
    navigate("/");
  };

  const menuUsuario = (
    <Menu>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        Cerrar sesión
      </Menu.Item>
    </Menu>
  );

  const menuItems = userRole === "Operador"
    ? [
      {
        key: "6",
        icon: <AndroidOutlined />,
        label: "Descargar App",
        onClick: () => { navigate("/download/app"); setDrawerVisible(false); },
      },
    ]
    : [
      {
        key: "1",
        icon: <CarryOutOutlined />,
        label: "Procesos",
        onClick: () => { navigate("/procesos"); setDrawerVisible(false); },
      },
      {
        key: "inventario",
        icon: <DatabaseOutlined />,
        label: "Inventario",
        onClick: () => { navigate("/inventario"); setDrawerVisible(false); },
      },
      {
        key: "packs",
        icon: <InboxOutlined />,
        label: "Despachos",
        onClick: () => { navigate("/packs"); setDrawerVisible(false); },
      },

      {
        key: "reportes_submenu",
        icon: <CloudDownloadOutlined />,
        label: "Reportes",
        children: [
          {
            key: "reporte_semanal",
            label: "Reporte Semanal",
            onClick: () => { navigate("/reportes/semanal"); setDrawerVisible(false); },
          },
          {
            key: "reporte_despachos",
            label: "Reporte Final de Envío",
            onClick: () => { navigate("/reportes/despachos"); setDrawerVisible(false); },
          }
        ]
      },
      {
        key: "3",
        icon: <TeamOutlined />,
        label: "Productores",
        onClick: () => { navigate("/productores"); setDrawerVisible(false); },
      },
      {
        key: "conductores",
        icon: <CarOutlined />,
        label: "Conductores",
        onClick: () => { navigate("/conductores"); setDrawerVisible(false); },
      },

      {
        key: "productos",
        icon: <TagOutlined />,
        label: "Productos",
        onClick: () => { navigate("/productos"); setDrawerVisible(false); },
      },
      {
        key: "exportadores",
        icon: <GlobalOutlined />,
        label: "Exportadores",
        onClick: () => { navigate("/exportadores"); setDrawerVisible(false); },
      },
      {
        key: "4",
        icon: <AppstoreOutlined />,
        label: "Tipos de Cajas",
        onClick: () => { navigate("/tipos-cajas"); setDrawerVisible(false); },
      },
      {
        key: "5",
        icon: <UserOutlined />,
        label: "Usuarios",
        onClick: () => { navigate("/usuarios"); setDrawerVisible(false); },
      },
      {
        key: "6",
        icon: <AndroidOutlined />,
        label: "Descargar App",
        onClick: () => { navigate("/download/app"); setDrawerVisible(false); },
      },
    ];

  // Contenido del Sider/Drawer para reutilizar
  const SideContent = (
    <>
      {/* Logo superior */}
      <div
        style={{
          textAlign: "center",
          padding: "20px 0",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          marginBottom: 10,
          background: "transparent"
        }}
      >
        <img
          src={logo}
          alt="Interpack"
          style={{
            maxWidth: "150px",
            height: "auto",
            display: "block",
            margin: "0 auto",
            filter: "brightness(0) invert(1)"
          }}
        />
      </div>

      {/* Menú principal */}
      <Menu
        theme="dark"
        mode="inline"
        style={{
          background: "transparent",
          fontSize: "15px",
          fontWeight: "500",
          border: "none",
        }}
        defaultSelectedKeys={["1"]}
        items={menuItems}
      />

      {/* Texto inferior fijo */}
      <div
        style={{
          position: "absolute",
          bottom: 10,
          width: "100%",
          textAlign: "center",
          borderTop: "1px solid rgba(255,255,255,0.2)",
          paddingTop: 8,
        }}
      >
        <Text style={{ color: "rgba(255,255,255,0.6)", fontSize: "13px" }}>
          YIDEASA © {new Date().getFullYear()}
        </Text>
      </div>
    </>
  );

  // Verificamos si es desktop (md o mayor)
  // Nota: inicialmente screens puede estar vacío en el primer render, así que asumimos desktop por defecto o manejamos loading.
  // Pero para layout visual, mejor defaulting a mobile first o desktop first. Aquí desktop first 'md' usually works.
  const isDesktop = screens.md;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sider para Desktop */}
      {isDesktop && (
        <Sider
          width={230}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
            background: "linear-gradient(180deg, #1677ff 0%, #0043a8 100%)",
            boxShadow: "2px 0 8px rgba(0,0,0,0.15)",
            zIndex: 100,
          }}
        >
          {SideContent}
        </Sider>
      )}

      {/* Drawer para Mobile */}
      {!isDesktop && (
        <Drawer
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{
            padding: 0,
            background: "linear-gradient(180deg, #1677ff 0%, #0043a8 100%)",
          }}
          width={230}
          closable={false}
        >
          {SideContent}
        </Drawer>
      )}

      <Layout style={{ marginLeft: isDesktop ? 230 : 0, transition: "all 0.2s" }}>
        <Header
          style={{
            position: "fixed",
            top: 0,
            left: isDesktop ? 230 : 0,
            right: 0,
            height: 64,
            background: "#fff",
            padding: "0 24px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            zIndex: 99,
            transition: "all 0.2s"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            {!isDesktop && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
                style={{ fontSize: '18px', width: 46, height: 46 }}
              />
            )}
            <Title level={4} style={{ margin: 0, color: "#1677ff", fontSize: isDesktop ? undefined : '16px' }}>
              {isDesktop ? "Panel de Administración" : "Panel"}
            </Title>
          </div>

          <Dropdown overlay={menuUsuario} placement="bottomRight" arrow>
            <Button type="text" icon={<UserOutlined />} style={{ color: "#1677ff" }}>
              <Space>{nombreUsuario}</Space>
            </Button>
          </Dropdown>
        </Header>

        <Content
          style={{
            marginTop: 80,
            padding: isDesktop ? "24px" : "16px",
            marginRight: isDesktop ? 24 : 0,
            marginLeft: isDesktop ? 24 : 0,
            background: "#fff",
            borderRadius: isDesktop ? "10px" : "0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            minHeight: "calc(100vh - 80px)",
            overflow: "auto",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
